export var COLOR;

(function (COLOR) {
  COLOR["brandOrange"] = "#ffa203";
  COLOR["brandGreen"] = "#00965e";
  COLOR["brandGreen20"] = "#cceadf";
  COLOR["darkGreen"] = "#4d5765";
  COLOR["black"] = "#000";
  COLOR["white"] = "#fff";
  COLOR["grey"] = "#2e3033";
  COLOR["lightGrey"] = "#ececec";
  COLOR["mediumGrey"] = "#979797";
})(COLOR || (COLOR = {}));

export var TRANSITION;

(function (TRANSITION) {
  TRANSITION["fast"] = "200ms";
  TRANSITION["slow"] = "300ms";
})(TRANSITION || (TRANSITION = {}));

export var typography = {
  h1: {
    fontSize: "4rem",
    lineHeight: "1.07",
    fontFamily: "SansCond",
    fontWeight: 700
  },
  h2: {
    fontSize: "2.5rem",
    lineHeight: "2.5rem",
    fontFamily: "SansCond",
    fontWeight: 700
  },
  h3: {
    fontSize: "2.1875",
    lineHeight: "1.14",
    fontFamily: "SansCond",
    fontWeight: 700
  },
  h4: {
    fontSize: "1.25rem",
    lineHeight: "1.2",
    fontFamily: "Sans",
    fontWeight: 700
  },
  h5: {
    fontSize: "1rem",
    lineHeight: "1.5",
    fontFamily: "Sans",
    fontWeight: 700
  },
  h6: {
    fontSize: "0.8125rem",
    lineHeight: "1.54",
    fontFamily: "Sans",
    fontWeight: 700
  },
  body: {
    fontSize: "1rem",
    lineHeight: "1.5",
    fontFamily: "Sans",
    fontWeight: 400
  },
  small: {
    fontSize: "0.8125rem",
    lineHeight: "1.5",
    fontFamily: "Sans",
    fontWeight: 400
  },
  smaller: {
    fontSize: "0.75rem",
    lineHeight: "1.25",
    fontFamily: "Sans",
    fontWeight: 400
  },
  mini: {
    fontSize: "0.625rem",
    lineHeight: "1.5",
    fontFamily: "Sans",
    fontWeight: 400
  },
  button: {
    fontSize: "1rem",
    lineHeight: "1.19",
    fontFamily: "Sans",
    fontWeight: 400
  },
  tile: {
    fontSize: "1rem",
    lineHeight: "1.25",
    fontFamily: "Sans",
    fontWeight: 400
  },
  tile2: {
    fontSize: "1.25rem",
    lineHeight: "1.2",
    fontFamily: "Sans",
    fontWeight: 700
  },
  tag: {
    fontSize: "0.75rem",
    lineHeight: "1",
    fontFamily: "Sans",
    fontWeight: 400
  }
};
var SIZE;

(function (SIZE) {
  SIZE["small"] = "576px";
  SIZE["medium"] = "768px";
  SIZE["large"] = "992px";
  SIZE["extraLarge"] = "1200px";
})(SIZE || (SIZE = {}));

;
export var BREAKPOINT = {
  xs: "(max-width: " + SIZE.small + ")",
  sm: "(min-width: " + SIZE.small + ")",
  md: "(min-width: " + SIZE.medium + ")",
  lg: "(min-width: " + SIZE.large + ")",
  xl: "(min-width: " + SIZE.extraLarge + ")"
}; // @media only screen and ${BREAKPOINT.LARGE}{}